module.exports = {
    testRedux: require('./app').testRedux,


    //localfilemanager
    SendObjectFileManager: require('./localfilemanager').sendObjectFileManager
}